import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
    Box, Typography, TextField, Switch, FormControlLabel,
    Button, Snackbar,
    Paper
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import { getAllExtraFees, updateExtraFee } from "../../Apis/DeliveryPriceApi";

const EditExtraFee = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [fee, setFee] = useState(null);
    const [amount, setAmount] = useState(0);
    const [status, setStatus] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

    useEffect(() => {
        const fetchFee = async () => {
            try {
                const response = await getAllExtraFees();
                const currentFee = response.extraFees.find(f => f.id === parseInt(id));
                if (currentFee) {
                    setFee(currentFee);
                    setAmount(currentFee.amount);
                    setStatus(currentFee.status);
                }
            } catch (err) {
                console.error(err);
            }
        };
        fetchFee();
    }, [id]);

    const handleSave = async () => {
        try {
            await updateExtraFee(fee.id, { type: fee.type, amount: Number(amount), status: Boolean(status) });
            setSnackbar({ open: true, message: "Fee updated!", severity: "success" });
            setTimeout(() => navigate("/extra-fees"), 1000);
        } catch (err) {
            console.error(err);
            setSnackbar({ open: true, message: "Failed to update fee.", severity: "error" });
        }
    };

    if (!fee) return <Typography>Loading...</Typography>;

    return (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
            <Paper sx={{ width: "400px", p: 4, borderRadius: 3, boxShadow: 3 }}>
                <Typography variant="h5" gutterBottom>
                    Edit Fee
                </Typography>
                <TextField
                    label="Type"
                    value={fee.type}
                    fullWidth
                    margin="normal"
                    InputProps={{ readOnly: true }}
                />
                <TextField
                    label="Amount"
                    type="number"
                    value={amount}
                    onChange={(e) => setAmount(e.target.value)}
                    fullWidth
                    margin="normal"
                />
                <FormControlLabel
                    control={<Switch checked={status} onChange={(e) => setStatus(e.target.checked)} />}
                    label="Active Status"
                />
                <Box sx={{ mt: 3, display: "flex", justifyContent: "space-between" }}>
                    <Button variant="contained" color="primary" onClick={handleSave}>
                        Save
                    </Button>
                    <Button variant="outlined" onClick={() => navigate("/extra-fees")}>
                        Cancel
                    </Button>
                </Box>

                <Snackbar
                    open={snackbar.open}
                    autoHideDuration={3000}
                    onClose={() => setSnackbar({ ...snackbar, open: false })}
                    anchorOrigin={{ vertical: "top", horizontal: "right" }}
                >
                    <MuiAlert
                        onClose={() => setSnackbar({ ...snackbar, open: false })}
                        severity={snackbar.severity}
                        variant="filled"
                        sx={{ width: "100%" }}
                    >
                        {snackbar.message}
                    </MuiAlert>
                </Snackbar>
            </Paper>
        </Box>
    );
};

export default EditExtraFee;
